import script from "./BedbugModalContent.vue?vue&type=script&setup=true&lang=js"
export * from "./BedbugModalContent.vue?vue&type=script&setup=true&lang=js"

import "./BedbugModalContent.vue?vue&type=style&index=0&id=5e597168&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e597168"]])

export default __exports__